/**
 * Icon for the on-device note drafting action.
 *
 * Not a generic "AI sparkle" — every product ships that, and it says nothing.
 * This draws the actual thing happening: a soundwave (the call recording)
 * resolving into note lines (the drafted notes), inside a rounded chip that
 * reads as a device. The story is "audio on this machine becomes text on this
 * machine", which is the whole point of the feature.
 *
 * currentColor throughout so it inherits button state (hover/disabled) and
 * works in both themes without a second asset.
 */
export function OnDeviceDraftIcon({
  className,
  title,
}: {
  className?: string;
  title?: string;
}) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth={1.7}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden={title ? undefined : true}
      role={title ? "img" : undefined}
    >
      {title ? <title>{title}</title> : null}

      {/* the device — deliberately open on the right so the note lines
          appear to leave it, rather than sitting boxed inside */}
      <path d="M15.5 3.25H5.4A2.15 2.15 0 0 0 3.25 5.4v13.2a2.15 2.15 0 0 0 2.15 2.15h10.1" opacity={0.55} />

      {/* soundwave: short-tall-short, the shape of speech */}
      <path d="M6.6 10.4v3.2" />
      <path d="M9.1 8.1v7.8" />
      <path d="M11.6 10.9v2.2" />

      {/* the resolve: waveform becomes written lines */}
      <path d="M14.6 9.5h5.9" opacity={0.9} />
      <path d="M14.6 12.6h5.9" opacity={0.75} />
      <path d="M14.6 15.7h3.6" opacity={0.6} />

      {/* single spark — one, small, at the point of transformation.
          Restraint is what keeps it from reading as stock AI chrome. */}
      <path d="M18.9 5.05l.45 1.15 1.15.45-1.15.45-.45 1.15-.45-1.15L17.3 6.65l1.15-.45z" fill="currentColor" stroke="none" />
    </svg>
  );
}
